import { setQueryStringForCurrentUrl, setQueryString } from 'utils/url';
import request from 'utils/request_ajax';
import { PATH_BUILDER } from 'constants/actionTypes';
import { routes } from 'constants/config';
import {
  requestReportingData,
  requestReportingDataSuccess,
} from './actionCreators';

function getReportingRoute(pathId, groupId) {
  const query = groupId ? { groupId } : {};
  return setQueryString(routes.PATH_REPORTING.INDEX(pathId), query);
}

export function setGroup(groupId) {
  const query = groupId ? { groupId } : {};
  setQueryStringForCurrentUrl(query);
  return {
    type: PATH_BUILDER.REPORTING.SET_GROUP,
    id: groupId,
  };
}

export function fetchData(groupId) {
  return (dispatch, getState) => {
    const { id: pathId } = getState().pathBuilder;
    dispatch(requestReportingData());
    request.get(getReportingRoute(pathId, groupId)).then(response => {
      dispatch(requestReportingDataSuccess(response));
    });
  };
}
